// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","button":"button-9nuGV","icon":"icon-2dthV","paper":"paper-1Sm2E","close":"close-3OqoX"};